/* Tecnolatina — megamenus premium (.tlx), carregados sob demanda (22/10/2026).
   Os 7 painéis NÃO vêm no HTML da página (pesavam ~82 KB gzip + 60 imagens em toda página, inclusive no celular).
   Só no computador: ocioso após o load → baixa a seção tl-megamenus (?section_id=) e o CSS; o painel de cada item
   entra no lugar do .tlx-slot no primeiro pointerover/foco do item (antes do tema medir a altura do submenu).
   Celular não baixa nada (lá vale a gaveta do tema). Depois: Escape, vídeo (janela ou no card), janela de conteúdo,
   eventos de analytics (tl_megamenu_open / tl_megamenu_click) e altura do painel pela tela real (--tlx-top). */
(() => {
  /* o bloco do menu é desenhado mais de uma vez no header: roda uma vez só */
  if (window.__tlxMega) return;
  window.__tlxMega = true;
  const script = document.currentScript;
  const URL_SECAO = script?.dataset.url;
  const URL_CSS = script?.dataset.css;
  const desktop = window.matchMedia('(hover: hover) and (min-width: 990px)');
  let paineis = null;
  let pedido = null;

  const css = () => new Promise((ok) => {
    if (!URL_CSS || document.querySelector('link[data-tlx-css]')) return ok();
    const l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = URL_CSS; l.dataset.tlxCss = '';
    l.onload = l.onerror = () => ok();
    document.head.append(l);
  });
  const buscar = () => {
    if (!pedido && URL_SECAO) {
      pedido = Promise.all([
        fetch(URL_SECAO, { credentials: 'same-origin' }).then((r) => (r.ok ? r.text() : '')),
        css(),
      ]).then(([t]) => {
        const doc = new DOMParser().parseFromString(t, 'text/html');
        paineis = {};
        doc.querySelectorAll('[data-tlx-panel]').forEach((p) => { paineis[p.dataset.tlxPanel] = p; });
        return paineis;
      }).catch(() => { pedido = null; return null; });
    }
    return pedido || Promise.resolve(null);
  };

  const hidratar = (li) => {
    const slot = li.querySelector('.tlx-slot');
    if (!slot) return true;
    const p = paineis?.[slot.dataset.tlxSlot];
    if (!p) return false;
    const frag = document.createDocumentFragment();
    document.importNode(p, true).childNodes.forEach((n) => frag.append(n.cloneNode(true)));
    slot.replaceWith(frag);
    init(li);
    return true;
  };
  const reabrir = (li) => {
    /* passou o mouse antes de o painel chegar: o tema mediu o submenu vazio — reativa para medir de novo */
    const menu = li.closest('header-menu');
    const trigger = li.querySelector(':scope > .menu-list__link');
    if (!menu || trigger?.getAttribute('aria-expanded') !== 'true') return;
    menu.deactivate({ target: li, relatedTarget: null });
    li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
  };
  const aoChegar = (e) => {
    if (!desktop.matches) return;
    const li = e.target?.closest?.('.menu-list__list-item');
    if (!li || !li.querySelector('.tlx-slot')) return;
    if (paineis) { hidratar(li); return; }
    buscar().then(() => { if (hidratar(li)) reabrir(li); });
  };
  /* captura na window: roda antes dos handlers do tema (pointerenter / focus no document) */
  window.addEventListener('pointerover', aoChegar, true);
  window.addEventListener('focus', aoChegar, true);
  /* o tema redesenha o header depois do load (morph): o marcador volta no lugar do painel. Religa o item aberto. */
  let agendado = false;
  new MutationObserver(() => {
    if (!paineis || agendado) return;
    agendado = true;
    requestAnimationFrame(() => {
      agendado = false;
      document.querySelectorAll('.menu-list__link[aria-expanded="true"]').forEach((t) => {
        const li = t.closest('.menu-list__list-item');
        if (li?.querySelector('.tlx-slot') && hidratar(li)) reabrir(li);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  /* Escape fecha o megamenu aberto mesmo sem foco dentro dele (janela aberta cuida do próprio Escape) */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || document.querySelector('dialog[open]')) return;
    const t = document.querySelector('.menu-list__list-item[data-tlx-init] > .menu-list__link[aria-expanded="true"]');
    if (!t) return;
    e.preventDefault();
    t.parentElement.__tlxFechar?.();
  });
  const preBuscar = () => { if (desktop.matches) buscar(); };
  const ocioso = () => ('requestIdleCallback' in window ? requestIdleCallback(preBuscar, { timeout: 4000 }) : setTimeout(preBuscar, 2500));
  if (document.readyState === 'complete') ocioso(); else window.addEventListener('load', ocioso, { once: true });
  desktop.addEventListener?.('change', preBuscar);

  /* ---------------- comportamento de cada painel ---------------- */
  function init(li) {
    const menu = li.closest('header-menu');
    const trigger = li.querySelector(':scope > .menu-list__link');
    if (!menu || !trigger || li.dataset.tlxInit) return;
    li.dataset.tlxInit = '1';

    const track = (name, data) => {
      const payload = { menu: li.querySelector('.tlx')?.dataset.tlMenu || '', ...data };
      try { window.Shopify?.analytics?.publish?.(name, payload); } catch (e) { /* sem pixel */ }
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
    };
    /* o foco de volta no item reabriria o painel (on:focus do tema): esse único foco é interceptado */
    const focusTrigger = () => {
      const block = (ev) => ev.stopImmediatePropagation();
      window.addEventListener('focus', block, { capture: true, once: true });
      trigger.focus();
      window.removeEventListener('focus', block, { capture: true });
    };
    const close = () => { focusTrigger(); menu.deactivate({ target: li, relatedTarget: null }); };
    li.__tlxFechar = close;

    /* janelas únicas no <body> (no markup do header o re-render do tema as duplicaria) */
    const fechar = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="m5 5 10 10M15 5 5 15"/></svg>';
    let modal = document.getElementById('tlx-video-modal');
    if (!modal) {
      modal = document.createElement('dialog');
      modal.id = 'tlx-video-modal'; modal.className = 'tlx-video-modal';
      modal.innerHTML = `<div class="tlx-video-modal__box"><button type="button" class="tlx-video-modal__close" aria-label="Fechar vídeo">${fechar}</button><div class="tlx-video-modal__frame"></div></div>`;
      document.body.append(modal);
      modal.addEventListener('click', (e) => { if (e.target === modal || e.target.closest('.tlx-video-modal__close')) modal.close(); });
    }
    const frame = modal.querySelector('.tlx-video-modal__frame');
    modal.addEventListener('close', () => { if (modal.dataset.dono !== trigger.getAttribute('aria-controls')) return; frame.innerHTML = ''; focusTrigger(); });
    let info = document.getElementById('tlx-info-modal');
    if (!info) {
      info = document.createElement('dialog');
      info.id = 'tlx-info-modal'; info.className = 'tlx-info-modal';
      info.innerHTML = `<div class="tlx-info-modal__box"><button type="button" class="tlx-info-modal__close" aria-label="Fechar">${fechar}</button><div class="tlx-info-modal__body"></div></div>`;
      document.body.append(info);
      info.addEventListener('click', (e) => { if (e.target === info || e.target.closest('.tlx-info-modal__close, [data-tl-fechar]')) info.close(); });
    }
    info.addEventListener('close', () => { if (info.dataset.dono === trigger.getAttribute('aria-controls')) focusTrigger(); });

    const iframe = (id, titulo, extra = '') => `<iframe src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1${extra}" title="${titulo}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
    const pararInline = () => li.querySelectorAll('.tlx-inline-frame').forEach((f) => f.remove());

    li.addEventListener('click', (e) => {
      /* vídeo no próprio card */
      const inline = e.target.closest('[data-yt][data-inline]');
      if (inline) {
        e.stopImmediatePropagation();
        pararInline();
        const box = inline.closest('.tlx__video');
        const titulo = box.dataset.titulo;
        box.insertAdjacentHTML('beforeend', `<div class="tlx-inline-frame${inline.dataset.formato === 'largo' ? ' tlx-inline-frame--largo' : ''}">${iframe(inline.dataset.yt, titulo, '&playsinline=1')}</div>`);
        if (inline.dataset.tlEv) track('tl_megamenu_click', { tipo: inline.dataset.tlEv, item: titulo, produto_id: null, destino: null });
        return;
      }
      /* vídeo na janela */
      const yt = e.target.closest('[data-yt]');
      if (yt) {
        const titulo = yt.closest('[data-titulo]')?.dataset.titulo || '';
        modal.setAttribute('aria-label', titulo);
        modal.dataset.dono = trigger.getAttribute('aria-controls');
        modal.classList.toggle('tlx-video-modal--vertical', yt.dataset.formato === 'vertical');
        frame.innerHTML = iframe(yt.dataset.yt, titulo);
        close(); trigger.blur(); modal.showModal();
      }
      /* janela de conteúdo (ex.: comparativo) */
      const dlg = e.target.closest('[data-tl-dialog]');
      const tpl = dlg && li.querySelector(`template#${dlg.dataset.tlDialog}`);
      if (tpl) {
        e.preventDefault();
        info.querySelector('.tlx-info-modal__body').replaceChildren(tpl.content.cloneNode(true));
        info.setAttribute('aria-label', tpl.dataset.titulo || '');
        info.dataset.dono = trigger.getAttribute('aria-controls');
        close(); trigger.blur(); info.showModal();
      }
      const el = e.target.closest('[data-tl-ev]');
      if (el) track('tl_megamenu_click', { tipo: el.dataset.tlEv, item: el.dataset.tlItem || el.textContent.trim().slice(0, 60), produto_id: el.dataset.tlId || null, destino: el.getAttribute('href') });
    });
    li.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse' || !document.activeElement?.closest?.('.tlx__video, .tlx-inline-frame')) return;
      document.activeElement.blur();
      menu.deactivate({ target: li, relatedTarget: null });
    });
    const aoMudar = () => {
      if (trigger.getAttribute('aria-expanded') !== 'true') { pararInline(); return; }
      li.style.setProperty('--tlx-top', `${Math.round(trigger.getBoundingClientRect().bottom + 16)}px`);
      track('tl_megamenu_open', {});
    };
    new MutationObserver(aoMudar).observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
    if (trigger.getAttribute('aria-expanded') === 'true') aoMudar();
  }
})();
